import {
  Avatar,
  Box,
  Button,
  Card,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import { Loading, useTranslate } from "react-admin";
import {
  createPaymentTransaction,
  getBaseEarn,
  getTotalPointwithPointOffer,
} from "../hooks/useMakeaPayment";
import { useContext, useEffect } from "react";

import AddIcon from "@material-ui/icons/Add";
import { ReactComponent as BinIcon } from "../assets/icons/bin.svg";
import CloseIcon from "@material-ui/icons/Close";
import { PaymentCreateContext } from "../pages/payment/payment-addproduct/PaymentCreateContext";
import RemoveIcon from "@material-ui/icons/Remove";
import SimplePopupDialog from "./SimplePopupDialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/core";
import mobileImage from "../assets/icons/temp/noimage.png";
import moment from "moment";
import pointIcon from "../assets/icons/point.png";
import { savePaymentState } from "../utils";
import { useHistory } from "react-router-dom";
import { useLocale } from "ra-core";
import { useLocation } from "react-router-dom";
import { usePopup } from "react-hook-popup";
import useTierInfo from "../hooks/useTierInfo";
import walletIcon from "../assets/icons/walleticon.png";

/**Config
 * MAXWIDTH is maxwidth of entire CartPanel
 */
const useStyles = makeStyles((theme) => ({
  allContainer: {
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      minWidth: "100%",
    },
    maxWidth: 335,
    minWidth: 335,
    background: "#fafafa",
    //display: "flex",
    display: "grid",
    gridTemplateRows: "125px 50px auto 40px 144px  75px",
    marginTop: 5,
    flexDirection: "column",
    zIndex: 999,
    maxHeight: "100%",
    overflowY: "hidden",
  },
  allContainerGuest: {
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
      minWidth: "100%",
    },
    maxWidth: 335,
    minWidth: 335,
    background: "#fafafa",
    //display: "flex",
    display: "grid",
    gridTemplateRows: " 50px auto 40px 144px 75px",
    marginTop: 5,
    flexDirection: "column",
    zIndex: 999,
    maxHeight: "100%",
    overflowY: "hidden",
  },
  deliverySection: {
    height: 50,
    display: "grid",
    gridTemplateColumns: "auto auto",
    textAlignLast: "center",
    alignItems: "center",
    padding: 1,
  },
  orderinBasketBar: {
    display: "flex",
    paddingTop: 50,
    boxSizing: "border-box",
    height: 50,
    justifyContent: "space-between",
    alignItems: "center",
  },
  orderinBasketBarMember: {
    display: "flex",
    paddingTop: 20,
    boxSizing: "border-box",
    height: 50,
    justifyContent: "space-between",
    alignItems: "center",
  },
  cartItemSection: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: 18,
    paddingRight: 18,
    marginTop: 15,
    boxSizing: "border-box",
    //flexGrow: 1,
    overflowX: "hidden" /* Hide horizontal scrollbar */,
    overflowY: "scroll" /* Add vertical scrollbar */,
    "&::-webkit-scrollbar": {
      width: 0,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.scrollbar.thumbColor,
    },
  },

  orderInBasketTitle: {
    fontSize: 20,
    marginLeft: 20,
  },
  clearAllButton: {
    width: 70,
    height: 30,
    fontSize: 12,
    color: theme.red,
    backgroundColor: theme.lightRed,
    padding: 4,
    marginRight: 18,
    borderRadius: 8,
    boxSizing: "border-box",
    textTransform: "none",
    boxShadow: "none",
  },

  cartItem_container: {
    width: "100%",
    height: 66,
    minHeight: 66,
    alignSelf: "center",
    marginTop: 12,
    display: "flex",
    alignItems: "center",
    position: "relative",
    borderRadius: 8,
    boxShadow:
      "0px 1px 1px 1px rgb(0 0 0 / 5%), 0px 3px 10px 0px rgb(0 0 0 / 5%), 0px -2px 0px 0px rgb(0 0 0 / 5%)",
  },
  cartItem_image: {
    marginLeft: 8,
    width: 29,
    height: 29,
  },
  cartItem_nameContainer: {
    marginLeft: 4,
    minWidth: 82,
    width: 82,
    maxWidth: 82,
    height: 47,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  cartItem_name: { fontSize: 12, fontWeight: "bold" },
  cartItem_id: { fontSize: 10, fontWeight: "lighter" },
  cartItem_qtyController: {
    marginLeft: 11,
    width: 81,
    height: 23,

    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  cartItem_price: {
    marginLeft: 12,
    width: 81,
    height: 23,
  },
  qtyButton: {
    width: 22,
    height: 22,
    borderRadius: 3,
    backgroundColor: "#f4f4f4",
  },
  qtyButton_icon: {
    width: 11,
    height: 11,
  },
  qtyText: {
    fontSize: 16,
    color: theme.darkGray,
  },
  qtyTextField: {
    fontSize: 16,
    color: theme.darkGray,
    width: 30,

    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  priceText: {
    fontSize: 14,
    color: theme.darkGray,
    fontWeight: 700,
  },
  binQtyButton: {
    width: 22,
    height: 22,
  },
}));

const useCustomerBarStyles = makeStyles((theme) => ({
  customerBarSection: {
    backgroundColor: theme.lightOrange,
    boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 10%)",
    width: "100%",
    height: 119,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: 5,
    paddingRight: 0,
    paddingTop: 10,
  },
  walletButton: {
    marginLeft: 20,
    width: 75,
    height: 68,
    backgroundColor: theme.orange,
    borderWidth: 0,
    borderRadius: 8,
    marginRight: 17,

    "&:focus": {
      outline: "none",
    },
    "&:hover": { backgroundColor: theme.darkOrange },
  },
  walletImage: { width: 32, height: 26 },
  nameContainer: { display: "flex", justifyContent: "space-between" },
  name: {
    fontSize: 16,
    color: theme.orange,
    fontWeight: 700,
  },
  avatar: {
    width: 48,
    height: 48,
    marginRight: 10,
  },
  alarmIcon: { width: 16, height: 20, marginLeft: 10 },
  allPointsInfoContainer: {
    display: "flex",
    marginTop: 5,
    alignItems: "center",
  },
  pointLeftColumn: {
    marginLeft: 0,
    minWidth: 75,
  },
  pointText: {
    fontSize: 30,
    fontWeight: 700,
    color: theme.orange,
    marginLeft: 5,
  },
  pointIcon: { width: 25, height: 25 },
  pointRightColumn: {
    marginLeft: 0,
  },
}));

const CartPanel = ({ lite }) => {
  const classes = useStyles();
  const [state, dispatch] = useContext(PaymentCreateContext);

  return (
    <Box
      className={
        state.member ? classes.allContainer : classes.allContainerGuest
      }
    >
      <CustomerBar lite={lite} />
      {lite ? (
        <>
          <Box />
          <Box />
        </>
      ) : (
        <>
          <OrderinBasketBar
            disableClearAll={IsSummarize() || state.items.length === 0}
            className={
              state.member
                ? classes.orderinBasketBarMember
                : classes.orderinBasketBar
            }
            onClick={() =>
              dispatch({
                type: "SHOW_CLEAR_ALL",
              })
            }
          />
          <ItemListSection className={classes.cartItemSection} />
        </>
      )}
      {/* <BottomBar className={classes.bottomBarSection} /> */}
      <DeliverySection />
      <AuthenticBottomBar />
    </Box>
  );
};

const DeliverySection = () => {
  const [state, dispatch] = useContext(PaymentCreateContext);
  const classes = useStyles();
  const translate = useTranslate();
  const history = useHistory();
  const locale = useLocale();

  return (
    <Box className={classes.deliverySection}>
      <Typography style={{ fontSize: 16, color: "#2f2b2b", fontWeight: 500 }}>
        {translate("ra.text.delivery_cost")}
      </Typography>
      <TextField
        defaultValue={state.deliveryCost ?? 0}
        onChange={(e) =>
          dispatch({
            type: "SET_DELIVERY_COST",
            payload: Number(e.target.value),
          })
        }
        disabled={IsSummarize()}
      />
    </Box>
  );
};

const CustomerBar = () => {
  const classes = useCustomerBarStyles();
  const [state, dispatch] = useContext(PaymentCreateContext);
  if (!state.member) return null;

  return (
    <Box className={classes.customerBarSection}>
      <IconButton
        className={classes.walletButton}
        onClick={() => {
          dispatch({
            type: "SHOW_POINT_AS_CASH",
          });
        }}
      >
        <img
          onClick={(e) => e.stopPropagation()}
          src={walletIcon}
          alt="wallet"
          style={{ pointerEvents: "none" }}
          className={classes.walletImage}
        />
      </IconButton>

      <Box>
        <Box className={classes.nameContainer}>
          <Typography align="center" className={classes.name}>
            {state.member
              ? `${state.member.firstname} ${state.member.lastname}`
              : "Mock data"}
          </Typography>
        </Box>
        <Box className={classes.allPointsInfoContainer}>
          {state.member ? (
            state.member.image_url ? (
              <Avatar
                className={classes.avatar}
                alt={state.member.firstname[0]}
                src={state.member.image_url}
              />
            ) : (
              <Avatar className={classes.avatar}>
                {state.member.firstname[0]}
              </Avatar>
            )
          ) : (
            <Avatar className={classes.avatar}></Avatar>
          )}
          <Box className={classes.pointLeftColumn}>
            <Box
              style={{ display: "flex", marginTop: 3, alignItems: "center" }}
            >
              <img
                src={pointIcon}
                alt="pointicon"
                className={classes.pointIcon}
              />
              <Typography className={classes.pointText}>
                {state.member.lifetime_value?.remaining_reward
                  ? Number(
                      state.member.lifetime_value.remaining_reward
                    ).toLocaleString()
                  : 0}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const CartItem = (props) => {
  const { index } = props;
  const classes = useStyles();
  const [state, dispatch] = useContext(PaymentCreateContext);
  //const location = useLocation();

  //const locationArray = location.pathname.split("/");
  if (IsSummarize()) {
    return (
      <Card className={classes.cartItem_container}>
        <Avatar
          alt={state.items[index].name}
          src={
            state.items[index].imageUrl
              ? state.items[index].imageUrl
              : mobileImage
          }
          className={classes.cartItem_image}
        ></Avatar>

        <Box className={classes.cartItem_nameContainer}>
          <Typography className={classes.cartItem_name} noWrap>
            {state.items[index].productName}
          </Typography>
          <Typography className={classes.cartItem_id} noWrap>
            {process.env.REACT_APP_CUSTOM_HIDE_PRODUCT_CODE === "yes"
              ? ""
              : state.items[index].code ?? ""}
          </Typography>
        </Box>
        <Box className={classes.cartItem_qtyController}>
          <Typography className={classes.qtyText}>
            {state.items[index].qty}
          </Typography>
        </Box>

        <Box className={classes.cartItem_price}>
          <Typography align="left" className={classes.priceText}>
            THB{" "}
            {Number(
              state.items[index].qty * state.items[index].chargeAmount
            ).toLocaleString()}
          </Typography>
        </Box>
      </Card>
    );
  }

  return (
    <Card className={classes.cartItem_container}>
      <CloseButton
        onClose={() => {
          return dispatch({
            type: "SHOW_CLEAR_ITEM",
            payload: {
              show: true,
              id: state.items[index].productId,
              name: state.items[index].productName,
              index: index,
            },
          });
        }}
      />
      <Avatar
        alt={state.items[index].name}
        src={
          state.items[index].imageUrl
            ? state.items[index].imageUrl
            : mobileImage
        }
        className={classes.cartItem_image}
      ></Avatar>

      <Box className={classes.cartItem_nameContainer}>
        <Typography className={classes.cartItem_name} noWrap>
          {state.items[index].productName}
        </Typography>
        <Typography className={classes.cartItem_id} noWrap>
          {state.items[index].code ?? ""}
        </Typography>
      </Box>
      <Box className={classes.cartItem_qtyController}>
        {state.items[index].qty === 1 ? (
          <BinIcon
            onClick={() => {
              return dispatch({
                type: "SHOW_CLEAR_ITEM",
                payload: {
                  show: true,
                  id: state.items[index].productId,
                  name: state.items[index].productName,
                  index: index,
                },
              });
            }}
          />
        ) : (
          <IconButton
            className={classes.qtyButton}
            onClick={() => {
              return dispatch({
                type: "REMOVE_PRODUCT",
                //  payload: state.items[index].productId,
                index: index,
              });
            }}
          >
            <RemoveIcon className={classes.qtyButton_icon} />
          </IconButton>
        )}

        <TextField
          className={classes.qtyTextField}
          value={state.items[index].qty || ""}
          inputProps={{ min: 0, style: { textAlign: "center" } }} // the change is here
          type="number"
          onChange={(e) => {
            if (e.target.value === "") {
              dispatch({
                type: "SET_PRODUCT_AMOUNT",
                qty: null,
                // payload: state.items[index].productId,
                index: index,
              });
            } else if (e.target.value === 0) {
              dispatch({
                type: "REMOVE_PRODUCT_TO_ZERO",

                index: index,
              });
            } else {
              dispatch({
                type: "SET_PRODUCT_AMOUNT",
                qty: Number(e.target.value),

                index: index,
              });
            }
          }}
        ></TextField>
        {/* <Typography className={classes.qtyText}>
          {state.items[index].qty}
        </Typography> */}
        <IconButton
          className={classes.qtyButton}
          size="small"
          onClick={() => {
            dispatch({
              type: "ADD_PRODUCT_AMOUNT",
              // payload: state.items[index].productId,
              index: index,
            });
          }}
        >
          <AddIcon className={classes.qtyButton_icon} />
        </IconButton>
      </Box>
      <Box className={classes.cartItem_price}>
        <Typography align="left" className={classes.priceText}>
          THB{" "}
          {Number(
            state.items[index].qty * state.items[index].chargeAmount
          ).toLocaleString()}
        </Typography>
      </Box>
    </Card>
  );
};

const OrderinBasketBar = ({ className, onClick, disableClearAll }) => {
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <div className={className}>
      <Typography className={classes.orderInBasketTitle}>
        {translate("ra.text.addProduct.orderinBasket")}
      </Typography>
      {disableClearAll ? null : (
        <Button
          className={classes.clearAllButton}
          variant="contained"
          onClick={onClick}
        >
          {translate("ra.text.addProduct.clearAll")}
        </Button>
      )}
    </div>
  );
};

const ItemListSection = ({ className }) => {
  const [state] = useContext(PaymentCreateContext);

  return (
    <Box className={className}>
      {state.member ? <TierinItemList /> : null}

      {state.items.map((_, index) => {
        return <CartItem key={index} index={index} />;
      })}
    </Box>
  );
};

const useTierinItemListStyles = makeStyles((theme) => ({
  allContainer: {
    backgroundColor: theme.lightGray,
    borderRadius: "12px",
    display: "flex",
    flexDirection: "row",
    minHeight: 66,
    maxHeight: 130,
    alignItems: "center",
    boxShadow:
      "0px 1px 1px 1px rgb(0 0 0 / 5%), 0px 3px 10px 0px rgb(0 0 0 / 5%), 0px -2px 0px 0px rgb(0 0 0 / 5%)",
  },
  tierImage: {
    marginLeft: 14,
    width: 39,
    height: 39,
  },
  nameContainer: { flexGrow: 1, marginLeft: 5, marginRight: 14 },
  tierText: { fontSize: 10, color: theme.darkGray },
  tierDiscountContainer: {
    flexGrow: 1,
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
  },
}));

const TierinItemList = () => {
  const [state, dispatch] = useContext(PaymentCreateContext);
  const classes = useTierinItemListStyles();

  const { tier, loading, error } = useTierInfo(state.member?.tier?.current.id);

  const tierImageUrl = state.member ? state.member.tier.current.image_url : "";
  const tierName = state.member ? state.member.tier.current.name : "";

  if (loading) return <Loading />;
  if (error) return null;

  //Hide item if user added some product
  if (state.items?.length > 0) return null;

  //What is this for?
  if (!state.currentTier) {
    if (!tier) return null;
    dispatch({
      type: "SET_MEMBER_TIER",
      payload: tier,
    });
  } else {
    //console.log("Have tier now? " + JSON.stringify(state));
  }

  if (state.disableTier) return <Box />;

  return (
    <Card className={classes.allContainer}>
      <Avatar
        alt={tierName}
        src={tierImageUrl}
        className={classes.tierImage}
      ></Avatar>

      <Box className={classes.nameContainer}>
        <Typography variant="subtitle2" className={classes.tierText} noWrap>
          Tier
        </Typography>
        <Box className={classes.tierDiscountContainer}>
          <Typography variant="h3" noWrap>
            {tierName}
          </Typography>
        </Box>
      </Box>
      <Box>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {tier
            ? tier.privileges.map((item, index) => {
                return (
                  <div
                    key={"TEIR" + index}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      width: "100%",
                      marginRight: 8,
                      marginTop: 16,
                    }}
                  >
                    <Typography
                      align="right"
                      style={{
                        fontSize: 28,
                        fontWeight: "bolder",
                        marginRight: 10,
                      }}
                    >
                      {item.condition.getMessage()}
                      {item.coupon.getTierMessage()}
                    </Typography>
                  </div>
                );
              })
            : null}
        </div>
      </Box>
    </Card>
  );
};

const useBottomBarStyles = makeStyles((theme) => ({
  tableContainer_root: {
    paddingLeft: 0,
    width: "90%",
    boxSizing: "border-box",
    margin: "10px auto",
    position: "relative",
    overflowX: "hidden",
  },
  tableRow: {
    height: 20,
    padding: 0,
    maxHeight: 20,
  },

  tableCell: {
    height: 20,
    padding: 0,
    borderBottom: "none",
  },
  tableCell_text: {
    fontSize: 12,
    padding: 0,
  },
  totalTableCell_text: {
    fontSize: 16,
    color: theme.blue,
    fontWeight: 700,
  },
  totalTableCell_point: {
    fontSize: 12,
    color: theme.orange,
    fontWeight: 400,
  },
  totalTableCell_pointGuest: {
    fontSize: 12,
    color: theme.gray,
    fontWeight: 400,
  },
  proceedButton: {
    width: 305,
    height: 57,
    margin: "0 auto 10px",
    // marginBottom: 10,
  },
  proceedButton_text: {
    fontWeight: 700,
    fontSize: 28,
    color: theme.white,
  },
}));

const TotalTableRow = ({ pricebeforeDiscount, deliveryCost = 0 }) => {
  const [state] = useContext(PaymentCreateContext);
  const classes = useBottomBarStyles();
  const translate = useTranslate();
  const totalPrice = GetTotalPrice(pricebeforeDiscount);
  const earnAmount = getTotalPointwithPointOffer(
    getBaseEarn(totalPrice),
    state.offer
  );

  let totalEarn = earnAmount;
  if (
    state.tierPrivileges &&
    state.tierPrivileges.length > 0 &&
    state.tierPrivileges[0].coupon
  ) {
    totalEarn = state.tierPrivileges[0].coupon.getEarnPointNumber(earnAmount);
  }
  return (
    <>
      <TableRow key="totaltablerow" classes={{ root: classes.tableRow }}>
        <TableCell align="left" size="small" className={classes.tableCell}>
          <Typography className={classes.totalTableCell_text}>
            {translate("ra.text.addProduct.total")}
          </Typography>
        </TableCell>

        <TotalTableCell totalPrice={totalPrice + deliveryCost} />
      </TableRow>
      <TableRow key="totaltablerow2" className={classes.tableRow}>
        <TableCell align="left" size="small" className={classes.tableCell}>
          <Typography
            className={
              state.member
                ? classes.totalTableCell_point
                : classes.totalTableCell_pointGuest
            }
          >
            {translate("ra.text.addProduct.pointtobeEarned")}
          </Typography>
        </TableCell>
        <TableCell
          style={{ paddingRight: 0 }}
          align="right"
          size="small"
          className={classes.tableCell}
        >
          <Typography
            className={
              state.member
                ? classes.totalTableCell_point
                : classes.totalTableCell_pointGuest
            }
          >
            {
              //getTotalPointwithPointOffer(getBaseEarn(totalPrice), state.offer)
              totalEarn
            }
          </Typography>
        </TableCell>
      </TableRow>
    </>
  );
};

const DiscountRow = ({ pricebeforeDiscount }) => {
  const [state] = useContext(PaymentCreateContext);
  const classes = useBottomBarStyles();
  return (
    <TableRow key="discountrow" classes={{ root: [classes.tableRow] }}>
      <TableCell align="left" size="small" className={classes.tableCell}>
        <Typography className={classes.tableCell_text}>
          {state.discount.coupons[0].type === "Discount"
            ? `Discount ${state.discount.coupons[0].value}`
            : `Discount ${state.discount.coupons[0].value}%`}
        </Typography>
      </TableCell>

      <CustomTableCell
        isPadding={false}
        label={
          state.discount.coupons[0].type === "Discount"
            ? `-${Number(
                Math.floor(parseFloat(state.discount.coupons[0].value))
              ).toLocaleString()}`
            : `-${Number(
                Math.floor(
                  parseFloat(state.discount.coupons[0].value / 100.0) *
                    pricebeforeDiscount
                )
              ).toLocaleString()}`
        }
        align="right"
      />
    </TableRow>
  );
};

const TierDiscountRow = ({ pricebeforeDiscount }) => {
  const [state] = useContext(PaymentCreateContext);
  const classes = useBottomBarStyles();

  return (
    <>
      {state.tierPrivileges?.map((privilege) => {
        return (
          <TableRow
            key="tierdiscountrow"
            classes={{
              root: [classes.tableRow],
            }}
          >
            <CustomTableCell
              isPadding={false}
              align="left"
              label={`${
                state.currentTier.name
              } ${state.currentTier.privileges[0]?.coupon?.getMessage()}`}
            />

            <CustomTableCell
              label={
                privilege.coupon?.type === "discount"
                  ? `-${privilege.coupon.getDiscountNumber(
                      pricebeforeDiscount
                    )}`
                  : ""
              }
              align="right"
            />
          </TableRow>
        );
      })}
    </>
  );
};

const PointasCashRow = () => {
  const [state] = useContext(PaymentCreateContext);
  const classes = useBottomBarStyles();
  const translate = useTranslate();
  return (
    <TableRow key="pointascashrow" classes={{ root: [classes.tableRow] }}>
      <TableCell align="left" size="small" className={classes.tableCell}>
        <Typography className={classes.tableCell_text}>
          {translate("ra.text.pointasCash")}{" "}
          {Math.abs(Number(state.pointasCash?.point)).toLocaleString()} points
        </Typography>
      </TableCell>

      <CustomTableCell
        label={`${Number(state.pointasCash.discount).toLocaleString()}`}
        align="right"
      />
    </TableRow>
  );
};

const OfferRow = () => {
  const [state] = useContext(PaymentCreateContext);
  const translate = useTranslate();
  const classes = useBottomBarStyles();
  const locale = useLocale();
  return (
    <TableRow key="offerrow" classes={{ root: [classes.tableRow] }}>
      <TableCell align="left" size="small" className={classes.tableCell}>
        <Typography className={classes.tableCell_text}>
          {translate("ra.text.specialOffers")}{" "}
          {`${state.offer.getOfferMessageInCart(locale)}`}
        </Typography>
      </TableCell>

      <CustomTableCell label="" align="right" />
    </TableRow>
  );
};

const CustomTableCell = ({ label, align, isPadding }) => {
  const classes = useBottomBarStyles({ align });
  return (
    <TableCell
      align={align}
      style={
        !isPadding
          ? {
              paddingRight: 0,
            }
          : null
      }
      size="small"
      className={classes.tableCell}
    >
      <Typography className={classes.tableCell_text}>{label}</Typography>
    </TableCell>
  );
};

const TotalTableCell = ({ totalPrice }) => {
  const classes = useBottomBarStyles();
  return (
    <TableCell
      style={{ paddingRight: 0 }}
      align="right"
      size="small"
      className={classes.tableCell}
    >
      <TotalPrice totalPrice={totalPrice} />
    </TableCell>
  );
};

const TotalPrice = ({ totalPrice }) => {
  //const [state] = useContext(PaymentCreateContext);
  const classes = useBottomBarStyles();

  return (
    <Typography className={classes.totalTableCell_text}>
      THB {Number(totalPrice).toLocaleString()}
    </Typography>
  );
};

const GetTotalPrice = (pricebeforeDiscount) => {
  const [state] = useContext(PaymentCreateContext);
  let discount = 0;
  if (state.discount) {
    discount =
      state.discount.coupons[0]?.type === "Discount"
        ? Math.floor(state.discount.coupons[0].value)
        : Math.floor(
            (state.discount.coupons[0].value * pricebeforeDiscount) / 100.0
          );
  }

  const pointDiscount = state.pointasCash?.discount
    ? -state.pointasCash?.discount
    : 0;

  const tierDiscount = state.tierPrivileges
    ? state.tierPrivileges.reduce((total, tierPrivilege) => {
        return (
          total + tierPrivilege.coupon.getDiscountNumber(pricebeforeDiscount)
        );
      }, 0)
    : 0;
  return pricebeforeDiscount - discount > 0
    ? pricebeforeDiscount - discount - pointDiscount - tierDiscount
    : 0;
};

const IsSummarize = () => {
  const location = useLocation();
  const locationArray = location.pathname.split("/");
  return (
    locationArray[locationArray.length - 1] === "channels" ||
    locationArray[locationArray.length - 1] === "other-channel" ||
    locationArray[locationArray.length - 1] === "lite"
  );
};

const AuthenticBottomBar = () => {
  const [state, dispatch] = useContext(PaymentCreateContext);
  const classes = useBottomBarStyles();
  const history = useHistory();
  const locale = useLocale();
  const transaction = createPaymentTransaction(state, locale);
  const [showAlert] = usePopup("alert", ({ message, handleClose }) => (
    <SimplePopupDialog
      message={message?.message}
      title={message?.title}
      handleClose={handleClose}
      error={true}
    />
  ));
  const translate = useTranslate();
  const isSummarize = IsSummarize();
  console.log(state);
  //return <>{JSON.stringify(transaction)}</>;
  return (
    <>
      <TableContainer
        component={Box}
        classes={{ root: classes.tableContainer_root }}
      >
        <Table
          style={{
            position: "absolute",
            bottom: 0,
            right: 0,
            left: 0,
          }}
        >
          <TableBody>
            <TableRow key="0" classes={{ root: classes.tableRow }}>
              <CustomTableCell
                label={translate("ra.text.receipt.subtotal")}
                align="left"
              />

              <CustomTableCell
                label={Number(
                  transaction.summary.total_payment
                ).toLocaleString()}
                align="right"
                isPadding={false}
              />
            </TableRow>
            <TierDiscountRow
              pricebeforeDiscount={transaction.summary.total_payment}
            />
            {state.discount ? (
              <DiscountRow
                pricebeforeDiscount={transaction.summary.total_payment}
              />
            ) : null}

            {state.offer ? <OfferRow /> : null}
            {state.pointasCash?.point > 0 ? <PointasCashRow /> : null}
            <TotalTableRow
              pricebeforeDiscount={transaction.summary.total_payment}
              deliveryCost={state.deliveryCost ?? 0}
            />
          </TableBody>
        </Table>
      </TableContainer>

      <Button
        variant="contained"
        color="primary"
        className={classes.proceedButton}
        onClick={() => {
          if (isSummarize) {
            return dispatch({ type: "SHOW_PAYMENT_CONFIRM" }); //last page;
          } else {
            //Check offer condition and other thing
            // if (transaction.summary.total_revenue <= 0) {
            //   return showAlert({
            //     title: "Can't proceed",
            //     message: "Payment can't be under 0",
            //   });
            // }

            if (
              state.discount &&
              !state.discount.isPassCondition(
                transaction.summary.total_qty,
                transaction.summary.total_payment,
                transaction.summary.total_revenue
              )
            )
              return showAlert({
                title: translate("ra.text.warningTitle"),
                message: `${translate("ra.text.doesnotMeetCondition")} 
                  ${translate("ra.text.discount")}"${
                  state.discount?.name
                }"  ${state.discount?.conditions[0]?.getMessage()}`,
              });
            if (
              state.offer &&
              !state.offer.isPassCondition(
                transaction.summary.total_qty,
                transaction.summary.total_payment,
                transaction.summary.total_revenue
              )
            )
              return showAlert({
                title: translate("ra.text.warningTitle"),
                message: `${translate("ra.text.doesnotMeetCondition")} 
                 ${translate("ra.text.offer")}"${
                  state.offer?.name
                }" ${state.offer?.conditions[0]?.getMessage()}`,
              });

            savePaymentState(state);

            // if (transaction.summary.total_revenue <= 0) {
            //   return history.push("/payment/other-channel");
            // }

            return history.push("/payment/channels");
          }
        }}
        disabled={
          isSummarize
            ? state.paymentChannels?.length <= 0
            : state.items?.length <= 0 ||
              state.items.some(
                (item) =>
                  item.qty === null || item.qty === "0" || item.qty === 0
              )
        }
      >
        <Typography className={classes.proceedButton_text}>
          {translate("ra.text.proceed")}
        </Typography>
      </Button>
    </>
  );
};

const useCloseButtonStyles = makeStyles((theme) => ({
  button: {
    minWidth: 15,
    maxWidth: 15,
    color: theme.white,
    marginLeft: 3,
  },
  container: {
    position: "absolute",
    top: 0,
    right: 0,
    width: 25,
    height: 22,
    background: "#d8d8d8",
    borderRadius: "0 0 0 6px",
  },
  icon: {
    width: 14,
    height: 14,
  },
}));
const CloseButton = ({ onClose }) => {
  const classes = useCloseButtonStyles();
  return (
    <Box className={classes.container}>
      <Button className={classes.button} onClick={onClose}>
        <CloseIcon className={classes.icon} />
      </Button>
    </Box>
  );
};

export default CartPanel;
